module.exports = __webpack_public_path__ + "static/media/interpharus.5a25dd0c.svg";